import { render, staticRenderFns } from "./dekt.vue?vue&type=template&id=054d6046&scoped=true&"
import script from "./dekt.vue?vue&type=script&lang=js&"
export * from "./dekt.vue?vue&type=script&lang=js&"
import style0 from "./dekt.vue?vue&type=style&index=0&id=054d6046&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d6046",
  null
  
)

export default component.exports